import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const MARQUEE_SPEED_PX_PER_SECOND = 30;

function HomeSliders({slidersMain, notice}) {
  const marqueeRef = useRef(null);
  const [marqueeDuration, setMarqueeDuration] = useState(40);

  // Scale the animation with the notice length so the strip always scrolls at a
  // readable pace, no matter how much text the backend sends.
  useEffect(() => {
    const strip = marqueeRef.current;
    if (!strip) return;

    const updateDuration = () => {
      const width = strip.scrollWidth;
      if (width > 0) {
        setMarqueeDuration(
          Math.max(30, Math.round((width * 1.5) / MARQUEE_SPEED_PX_PER_SECOND))
        );
      }
    };

    updateDuration();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateDuration).catch(() => {});
    }
  }, [notice]);

  return (
    <div className="home-banner-box banner-content">
      {/* ✅ Mobile Carousel */}
      <div className="hidden-md-and-up">
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          style={{ width: "100%", height: "auto" }}
        >
          {slidersMain.map((img, index) => (
            <SwiperSlide key={index}>
              <div
                className="banner-slide"
                style={{
                  backgroundImage: `url(${process.env.REACT_APP_API_URL}/storage/${img.thubmnail})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  width: "100%",
                  paddingBottom: "44.44%",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      

      {/* ✅ Scrolling marquee */}
      <div
        className="row marquee-row no-gutters"
        style={{ padding: "1% 12%", backgroundColor: "rgb(21, 9, 46)" }}
      >
        <div className="marquee-wrapper">
          <div
            className="marquee-content"
            ref={marqueeRef}
            style={{ animationDuration: `${marqueeDuration}s` }}
          >
            <span className="pr-6 mr-6">
              { notice.map((item, index) => (
              <label
                className="d-inline-block home-announcment-content"
                style={{ color: "rgb(198, 255, 0)" }}
              >
               {item}
              </label>
             ))}
            </span>

         
          

          
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeSliders;
